<rl-dialog-window (onClose)="close()" [title]="'quickCite.title'">
    <div class="modal-section no-margin">
        <form class="form-flex editable-content border-rows">
            <fieldset>
                <div class="form-flex-row">
                    <div class="form-flex-label">
                        <label for="bibStyle">{{'quickCite.bibStyle'| translate}}:</label>
                    </div>
                    <div class="form-flex-input">
                        <select [(ngModel)]="style" (ngModelChange)="changeStyle()" id="bibStyle" class="form-control form-input-bg-color" name="bibStyle">
                            <option *ngFor="let i of styles" [ngValue]="i">{{i.label}}</option>
                        </select>
                    </div>
                </div>
            </fieldset>
        </form>
        <p [innerHtml]="citationText"></p>
        <div class="justify-content">
            <div class="flex-end">
                <button type="button" class="btn btn-link" id="copy-to-clipboard" *ngIf="displayCopyButton" (click)="copyToClipboard()" [rlAria]="'quickCite.copyToClipboard' | translate"><i class="fa fa-clipboard"></i> {{'quickCite.copyToClipboard'| translate}}</button>
                <p *ngIf="!displayCopyButton" class="Approved" aria-live="assertive">
                    <i class="fa fa-check"></i> {{'quickCite.itemWasCopidToClipboard' | translate}}
                </p>
            </div>
        </div>
        <p class="no-margin normal-text label-warning">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{'quickCite.warning' | translate}}
        </p>
    </div> 
    <rl-please-wait *ngIf="busy" disable="false"></rl-please-wait>
</rl-dialog-window>
 